module.exports = __webpack_public_path__ + "static/media/mango_un.72d585ea.png";